module.exports = __webpack_public_path__ + "img/course101.1d4f50f9.png";